import { c as _c } from "react/compiler-runtime";
import { Formik, useField } from 'formik';
import { useContext } from 'react';
import styled, { css } from 'styled-components';
import useSWR from 'swr';
import { Grid, GridUnit } from '@hookdeck/theme';
import APIMethodKeys from '../../../../../client/APIMethodKeys';
import { showChat } from '../../../../../utils/liveChat';
import Badge from '../../../../common/base/Badge';
import { StyledCard, StyledCardSection } from '../../../../common/base/Card';
import Divider from '../../../../common/base/Divider';
import Icon from '../../../../common/base/Icon';
import Link from '../../../../common/base/Link';
import Text from '../../../../common/base/Text';
import { StyledRadio } from '../../../../common/Form/Fields/RadioInput';
import { Div } from '../../../../common/helpers/StyledUtils';
import Modal from '../../../../common/Modal';
import { useToasts } from '../../../../common/Toast';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { TeamPermission } from '../../../../contexts/TeamPermissionContext';
import useSearchQuery from '../../../../hooks/useSearchQuery';
import { DashboardContext } from '../../DashboardContext';
const StyleRadioRow = styled(StyledRadio)(({
  theme,
  checked
}) => css`
    ${checked && css`
      background-color: ${theme.colors.surface.base.variant_surface_2};
    `}
  `);
const RadioTableInput: React.FC<{
  current_value: number;
  tiers: {
    [key: number]: {
      compare_at_price: number;
      price: number;
      legacy: boolean;
    };
  };
  name: string;
}> = t0 => {
  const $ = _c(35);
  const {
    tiers,
    name,
    current_value
  } = t0;
  const [field] = useField(name);
  const {
    team_role
  } = useContext(DashboardContext);
  let t1;
  if ($[0] !== tiers) {
    t1 = Object.entries(tiers);
    $[0] = tiers;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const tiers_array = t1;
  const disabled = team_role !== "admin";
  let t2;
  if ($[2] !== current_value || $[3] !== disabled || $[4] !== field || $[5] !== name || $[6] !== tiers_array) {
    t2 = tiers_array.map(t3 => {
      const [tier, config] = t3;
      return <StyledCardSection key={tier}><StyleRadioRow key={tier} as="label" inline={true} highlight={true} disabled={disabled} m={0} p={3} checked={field.value === tier}><Grid><GridUnit size={0.5}><Div flex={{
                align: "center"
              }}><input {...field} onChange={() => field.onChange({
                  target: {
                    value: tier,
                    name
                  }
                })} checked={field.value === tier} disabled={disabled} type="radio" /><Text semi={true} m={{
                  l: 2
                }}>{tier} events per second</Text>{current_value === Number(tier) && <Badge m={{
                  l: 2
                }} primary={true} subtle={true}>Current {config.legacy && "(Legacy)"}</Badge>}</Div></GridUnit><GridUnit size={0.5}><Div flex={{
                justify: "flex-end",
                gap: 2
              }}>{config.compare_at_price ? <Text muted={true} semi={true} strike={true}>${(config.compare_at_price / 100).toFixed(2)}</Text> : null}<Text semi={true}>${(config.price / 100).toFixed(2)}</Text></Div></GridUnit></Grid></StyleRadioRow></StyledCardSection>;
    });
    $[2] = current_value;
    $[3] = disabled;
    $[4] = field;
    $[5] = name;
    $[6] = tiers_array;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = field.value === "custom";
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      align: "center"
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== field || $[10] !== name) {
    t5 = () => field.onChange({
      target: {
        value: "custom",
        name
      }
    });
    $[9] = field;
    $[10] = name;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = field.value === "custom";
  let t7;
  if ($[12] !== disabled || $[13] !== field || $[14] !== t5 || $[15] !== t6) {
    t7 = <input {...field} onChange={t5} checked={t6} disabled={disabled} type="radio" />;
    $[12] = disabled;
    $[13] = field;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      l: 2
    };
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== tiers) {
    t9 = Object.keys(tiers);
    $[18] = tiers;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = t9[Object.keys(tiers).length - 1];
  let t11;
  if ($[20] !== t10) {
    t11 = <Text m={t8} semi={true}>{">"} {t10} events per second</Text>;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t7) {
    t12 = <GridUnit size={0.5}><Div flex={t4}>{t7}{t11}</Div></GridUnit>;
    $[22] = t11;
    $[23] = t7;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <GridUnit size={0.5}><Div flex={{
        justify: "flex-end",
        gap: 2
      }}><Link onClick={showChat} neutral={true}>Contact Us</Link></Div></GridUnit>;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12) {
    t14 = <Grid>{t12}{t13}</Grid>;
    $[26] = t12;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== disabled || $[29] !== t14 || $[30] !== t3) {
    t15 = <StyledCardSection><StyleRadioRow as="label" inline={true} highlight={true} disabled={disabled} m={0} p={3} checked={t3}>{t14}</StyleRadioRow></StyledCardSection>;
    $[28] = disabled;
    $[29] = t14;
    $[30] = t3;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t15 || $[33] !== t2) {
    t16 = <><div role="group">{t2}{t15}</div></>;
    $[32] = t15;
    $[33] = t2;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
};
const ChangeThrouhgputModal: React.FC = () => {
  const $ = _c(24);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    team,
    team_role,
    subscription,
    mutateTeam
  } = useContext(DashboardContext);
  const {
    addToast
  } = useToasts();
  const {
    updateSearchQuery
  } = useSearchQuery();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = APIMethodKeys.billing.getThroughputTiers();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== HookdeckAPI.billing) {
    t1 = () => HookdeckAPI.billing.getThroughputTiers();
    $[1] = HookdeckAPI.billing;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: tiers
  } = useSWR(t0, t1);
  let t2;
  if ($[3] !== updateSearchQuery) {
    t2 = () => {
      updateSearchQuery({
        view: undefined
      });
    };
    $[3] = updateSearchQuery;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onClose = t2;
  let t3;
  if ($[5] !== HookdeckAPI.billing || $[6] !== addToast || $[7] !== mutateTeam || $[8] !== onClose || $[9] !== team.max_events_per_second) {
    t3 = async values => {
      if (values.throughput_tier === team.max_events_per_second) {
        return;
      }
      return HookdeckAPI.billing.updateThroughput(Number(values.throughput_tier)).then(team_0 => {
        mutateTeam(team_0);
        addToast("success", "Project throughput successfully updated.");
        onClose();
      }).catch(() => {
        addToast("error", "Failed to update project throughput.");
      });
    };
    $[5] = HookdeckAPI.billing;
    $[6] = addToast;
    $[7] = mutateTeam;
    $[8] = onClose;
    $[9] = team.max_events_per_second;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const onSubmit = t3;
  const t4 = String(team.max_events_per_second);
  let t5;
  if ($[11] !== t4) {
    t5 = {
      throughput_tier: t4
    };
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== onClose || $[14] !== subscription || $[15] !== team.billing_meta.included || $[16] !== team.max_events_per_second || $[17] !== team_role || $[18] !== tiers) {
    t6 = props => <form onSubmit={props.handleSubmit}><TeamPermission role="admin"><Modal size="large" title="Change project throughput" submit_label={props.values.sku === "custom" ? "Contact us" : "Update throughput"} cancel_label="Cancel" hide_close={true} submit_disabled={team_role === "admin" && Number(props.values.throughput_tier) === team.max_events_per_second} onSubmit={props.handleSubmit} onCancel={onClose} onClose={onClose} is_submitting={props.isSubmitting}><Text as="p">Project throughput sets the maximum events per second for each destination in this project. Delivery within this rate is within SLA; above it is best effort. Upon changing throughput, you will be charged the corresponding fee. You can change your throughput at any time. Reducing your throughput will grant a pro-rated credit.</Text>{team.billing_meta.included !== null && team.billing_meta.included > 0 && subscription?.included_throughput && subscription?.included_throughput > 0 ? <Div flex={true} m={{
            b: 4
          }}><Icon icon="info" left={true} muted={true} m={{
              t: 0.5
            }} /><Text muted={true}>This project throughput is discounted for {subscription.included_throughput}{" "}events/s because of a grandfathered plan.</Text></Div> : null}<StyledCard overflow_hidden={true}><StyledCardSection muted={true} p={{
              y: 1,
              x: 3
            }}><Grid><GridUnit size={0.5}><Text semi={true} muted={true} size="s">Throughput rate</Text></GridUnit><GridUnit size={0.5}><Div flex={{
                    justify: "flex-end"
                  }}><Text semi={true} muted={true} size="s">Price per month</Text></Div></GridUnit></Grid></StyledCardSection><Divider />{tiers && <Div max_h={{
              vh: 50
            }} style={{
              overflow: "auto"
            }}><RadioTableInput current_value={team.max_events_per_second} tiers={tiers} name="throughput_tier" /></Div>}</StyledCard></Modal></TeamPermission></form>;
    $[13] = onClose;
    $[14] = subscription;
    $[15] = team.billing_meta.included;
    $[16] = team.max_events_per_second;
    $[17] = team_role;
    $[18] = tiers;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== onSubmit || $[21] !== t5 || $[22] !== t6) {
    t7 = <Formik initialValues={t5} onSubmit={onSubmit}>{t6}</Formik>;
    $[20] = onSubmit;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
};
export default ChangeThrouhgputModal;